import permission from './permission'
import permissionButton from './permissionButton'
import permissionDropdown from './permissionDropdown'

const install = function(Vue) {
  Vue.directive('permission', permission)
  Vue.directive('permissionButton', permissionButton)
  Vue.directive('permissionDropdown', permissionDropdown)
}

if (window.Vue) {
  window['permission'] = permission
  Vue.use(install); // eslint-disable-line
}

permission.install = install
export default permission
